import $ from 'jquery';
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import "vue-select/dist/vue-select.css";
import Toasted from 'vue-toasted';
import { initClient } from '../../../api';
import { ActivityControllerUIClient, DutyClient, IActivity } from "../../backend/backendapi";
import { EnumStatus } from '../../activitymodal/activitymodal.model';

Vue.use(Toasted, { duration: 2000 });

@Component({
    name: 'CreateActivityModal',
    components: {
    }
})
export default class CreateActivityModal extends Vue {
    @Prop({ required: true })
    readonly modalId!: string;
    @Prop({ required: true })
    readonly dutyId!: number;
    @Prop({ required: true })
    readonly title!: string;

    private reference: string | null = null;
    private skipNextAutoTrigger: boolean = false;

    private readonly dutyApi = initClient(DutyClient);
    private readonly activityApi = initClient(ActivityControllerUIClient);

    mounted(): void {
    }

    openModal(): void {
        $('#' + this.modalId).modal('show');
        setTimeout(() => (this.$refs.createButton as HTMLButtonElement).focus(), 500);
    }

    closeModal(): void {
        $('#' + this.modalId).modal('hide');
    }

    private async createActivity(): Promise<void> {
        try {
            let activity = (await this.dutyApi.createActivityConfirmed(this.dutyId, this.skipNextAutoTrigger)).result!;
            if (activity.title !== this.title || this.reference?.trim().length) {
                activity.title = this.title.trim();
                activity.reference = this.reference?.trim();
                activity.status = EnumStatus.Changed; // trigger status only once per activity
                await this.activityApi.updateActivity(activity);
            }
            this.closeModal();
            this.$toasted.info(this.$t('txtCreated').toString());
            this.$emit('created');
        } catch (e) {
            this.$toasted.error(this.$t('txtError') + ': ' + JSON.stringify(e));
        }
    }
}